function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if ( !customElements.get('quantity-selector') ) {
	class QuantityInput extends HTMLElement  {
	  constructor() {
			super();
	    this.input = this.querySelector('.qty');
	    this.changeEvent = new Event('change', {
	      bubbles: true
	    });
	    // Create buttons
	    this.subtract = this.querySelector('.minus');
	    this.add = this.querySelector('.plus');

	    // Add functionality to buttons
	    this.subtract.addEventListener('click', () => this.change_quantity(-1));
	    this.add.addEventListener('click', () => this.change_quantity(1));

	  }
		connectedCallback() {
			this.classList.add('buttons_added');
		}
	  change_quantity(change) {
	    // Get current value
	    let quantity = Number(this.input.value);

	    // Ensure quantity is a valid number
	    if (isNaN(quantity)) quantity = 1;

	    // Change quantity
	    quantity += change;

	    // Ensure quantity is always a number
	    quantity = Math.max(quantity, 1);

	    // Output number
	    this.input.value = quantity;

	    this.input.dispatchEvent(this.changeEvent);
	  }
	}
	customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
		this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
			this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
	class ProductCard extends HTMLElement {
		constructor() {
	    super();
			this.swatches = this.querySelector('.product-card-swatches');
	    this.image = this.querySelector('.product-featured-image-link .product-primary-image');
	    this.additional_images = this.querySelectorAll('.product-secondary-image');
			this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
	    this.quickview_button = this.querySelector('.product-card-quickview');
		}
		connectedCallback() {
			if (this.swatches) {
	      this.enableSwatches(this.swatches, this.image);
	    }
	    if (this.quickview_button) {
	      this.enableQuickview(this.quickview_button);
	    }
			if (this.additional_images) {
	      this.enableAdditionalImages();
	    }
		}
		enableAdditionalImages() {
				let image_length = this.additional_images.length;
				let images = this.additional_images;
				let nav = this.additional_images_nav;
				let image_container = this.querySelector('.product-featured-image');
				const mousemove = function(e) {
					let l = e.offsetX;
		      let w = this.getBoundingClientRect().width;
		      let prc = l/w;
		      let sel = Math.floor(prc*image_length);
		      let selimg = images[sel];
					images.forEach((image, index) => {
						if ( image.classList.contains('hover') ) {
							image.classList.remove('hover');
							if ( nav.length ) {
								nav[index].classList.remove('active');
							}
						}
					});
					if ( selimg ) {
						if ( ! selimg.classList.contains('hover') ) {
				      selimg.classList.add('hover');
							if ( nav.length ) {
								nav[sel].classList.add('active');
							}
						}
					}

				};
				const mouseleave = function(e) {
					images.forEach((image, index) => {
						image.classList.remove('hover');
						if ( nav.length ) {
							nav[index].classList.remove('active');
						}
					});
				};
				image_container.addEventListener( 'touchstart', mousemove, { passive: true } );
				image_container.addEventListener( 'touchmove', mousemove, { passive: true } );
				image_container.addEventListener( 'touchend', mouseleave, { passive: true } );
				image_container.addEventListener( 'mouseenter', mousemove, { passive: true } );
				image_container.addEventListener( 'mousemove', mousemove, { passive: true } );
				image_container.addEventListener( 'mouseleave', mouseleave, { passive: true } );
		}
		enableSwatches(swatches, image) {
	    let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
					org_srcset = image ? image.dataset.srcset : '',
		      active = swatches.querySelector('.product-card-swatch.active');

	    swatch_list.forEach((swatch, index) => {

	      swatch.addEventListener('mouseover', function() {

	        [].forEach.call(swatch_list, function(el) {
	          el.classList.remove('active');
	        });
					if ( image ) {
						if ( swatch.dataset.srcset  ) {
		          image.setAttribute('srcset', swatch.dataset.srcset);
						} else {
							image.setAttribute('srcset', org_srcset);
						}
	        }

	        swatch.classList.add('active');
	      });
	      swatch.addEventListener('click', function(evt) {
	        window.location.href = this.dataset.href;
	        evt.preventDefault();
	      });
	    });
	  }
	  enableQuickview(quickview_button) {
	    const _this = this,
	      drawer = document.getElementById('Product-Drawer'),
	      body = document.body;

			quickview_button.addEventListener('click', function(evt) {
	      evt.preventDefault();
	      let productHandle = quickview_button.dataset.productHandle,
	        	href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

	      // remove double `/` in case shop might have /en or language in URL
	      href = href.replace('//', '/');
	      if (!href || !productHandle) {
	        return;
	      }
	      if (quickview_button.classList.contains('loading')) {
	        return;
	      }
	      quickview_button.classList.add('loading');
	      fetch(href, {
	          method: 'GET'
	        })
	        .then((response) => {
	          quickview_button.classList.remove('loading');
	          return response.text();
	        })
	        .then(text => {
	          const sectionInnerHTML = new DOMParser()
	            .parseFromString(text, 'text/html')
	            .querySelector('#Product-Drawer-Content').innerHTML;
	          _this.renderQuickview(sectionInnerHTML, drawer, body, href, productHandle);

	        });
	    });
	  }
	  renderQuickview(sectionInnerHTML, drawer, body, href, productHandle) {
	    if (sectionInnerHTML) {
	      drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
	      let quantity = drawer.querySelector('.quantity:not(.buttons_added)');

	      setTimeout(() => {
	        if (Shopify && Shopify.PaymentButton) {
	          Shopify.PaymentButton.init();
	        }
	      }, 300);
	      body.classList.add('open-cc');
	      drawer.classList.add('active');
				setTimeout(() => {
		      drawer.querySelector('.product-quick-images--container').classList.add('active');
		    });
				drawer.querySelector('.side-panel-close').focus();
				dispatchCustomEvent('quick-view:open', {
					productUrl: href,
					productHandle: productHandle
				});
	    }
	  }
	}
	customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
		const header = document.getElementById('shopify-section-header'),
					header_main = document.getElementById("header"),
    			menu = document.getElementById('mobile-menu'),
				 	toggle = document.querySelector('.mobile-toggle-wrapper'),
					setHeaderOffset = this.setHeaderOffset,
					setAnnouncementHeight = this.setAnnouncementHeight,
					setHeaderHeight = this.setHeaderHeight;

    document.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        toggle.removeAttribute('open');
				toggle.classList.remove('open');
      }
    });
		toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
			setAnnouncementHeight( header );
			if ( toggle.classList.contains('active')) {
				e.preventDefault();
				document.body.classList.remove('overflow-hidden');
				toggle.classList.remove('active');
				this.closeAnimation(toggle);
			} else {
				document.body.classList.add('overflow-hidden');
				setTimeout(() => {
		      toggle.classList.add('active');
		    });
			}
			window.dispatchEvent( new Event('resize.resize-select') );
    });

		// Sticky Header Class
		let observer = new IntersectionObserver(function(entries) {
      if (entries[0].intersectionRatio === 0) {
        header_main.classList.add("is-sticky");
      } else if (entries[0].intersectionRatio === 1) {
        header_main.classList.remove("is-sticky");
      }
    }, {
      threshold: [0, 1]
    });
    observer.observe(document.querySelector(".header--sticky"));

		// Mobile Menu offset
		window.addEventListener('scroll', function() {
			setHeaderOffset(header);
			setHeaderHeight(header_main);
		});
		window.dispatchEvent( new Event('scroll') );

		if ( document.getElementById('shopify-section-announcement-bar') ) {
			const a_bar = document.getElementById('shopify-section-announcement-bar');
			window.addEventListener('resize', function() {
				setAnnouncementHeight(a_bar);
			}, { passive: true } );
			window.dispatchEvent( new Event('resize') );
		}
		// Buttons.
		menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
		menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
	setAnnouncementHeight(a_bar) {
		let h = a_bar.clientHeight;
		document.documentElement.style.setProperty('--announcement-height', h + 'px');
	}
	setHeaderOffset(header) {
		let h = header.getBoundingClientRect().top;
		document.documentElement.style.setProperty('--header-offset', h + 'px');
	}
	setHeaderHeight(header) {
		let h = header.clientHeight;
		document.documentElement.style.setProperty('--header-height', h + 'px');
	}
	onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

		setTimeout(() => {
			detailsElement.classList.add('menu-opening');
			parentMenuElement && parentMenuElement.classList.add('submenu-open');
		}, 100);
  }
	onCloseButtonClick(event) {
		event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
	closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
		this.closeAnimation(detailsElement);
  }
	closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
	class FullMenu extends HTMLElement {
		constructor() {
	    super();

			this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
		}
		connectedCallback() {
			if (!this.submenus.length) {
				return;
			}
			const _this = this;
			// resize on initial load
			document.fonts.ready.then(function() {
				window.addEventListener('resize', debounce(function() {
					_this.resizeSubMenus();
				}, 100));
			});

		}
		resizeSubMenus() {
			this.submenus.forEach((submenu) => {
				let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

				sub_submenus.forEach((sub_submenu) => {
					let w = sub_submenu.offsetWidth,
							l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
							total = w + l;

					if ( total > window.innerWidth) {
						sub_submenu.parentElement.classList.add('left-submenu');
					} else if ( sub_submenu.parentElement.classList.contains('left-submenu') ) {
						sub_submenu.parentElement.classList.remove('left-submenu');
					}
				});
			});
		}
	}
	customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
		super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        document.querySelectorAll('.side-panel').forEach((panel) => {
					if ( panel.classList.contains('product-drawer')) {
						if ( panel.querySelector('.product-quick-images--container') ) {

							panel.querySelector('.product-quick-images--container').classList.remove('active');
						}
						if ( window.innerWidth < 1069 ) {
							panel.classList.remove('active');
							document.body.classList.remove('open-cc');
						} else {
							if ( panel.querySelector('.product-quick-images--container') ) {
								panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
									panel.classList.remove('active');
									document.body.classList.remove('open-cc');
								});
							}
						}
					} else {
						panel.classList.remove('active');
				    document.body.classList.remove('open-cc');
					}
        });
      }
    });
    cc.addEventListener('click', (e) => {
			let panel = document.querySelector('.side-panel.active');
			if (panel) {
				if ( panel.classList.contains('product-drawer')) {
					panel.querySelector('.product-quick-images--container').classList.remove('active');
					if ( window.innerWidth < 1069 ) {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
					} else {
						panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
							panel.classList.remove('active');
							document.body.classList.remove('open-cc');
						});
					}
				} else {
					panel.classList.remove('active');
			    document.body.classList.remove('open-cc');
				}
			}
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
		if ( panel.classList.contains('product-drawer')) {
			if ( panel.querySelector('.product-quick-images--container') ) {
				panel.querySelector('.product-quick-images--container').classList.remove('active');
			}
			if ( window.innerWidth < 1069 ) {
				panel.classList.remove('active');
				document.body.classList.remove('open-cc');
			} else {
				if ( panel.querySelector('.product-quick-images--container') ) {
					panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
					});
				}
			}
		} else {
			panel.classList.remove('active');
			document.body.classList.remove('open-cc');
		}

  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

		if ( ! this.container ) {
			return;
		}
    let _this = this,
				button = document.getElementById('cart-drawer-toggle'),
	      quantities = this.container.querySelectorAll('.quantity input'),
	      removes = this.container.querySelectorAll('.remove');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
			this.container.focus();
			dispatchCustomEvent('cart-drawer:open');
    });


    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

		this.notesToggle();
  }
  onChange(event) {
		if ( event.target.classList.contains('qty')) {
			this.updateQuantity(event.target.dataset.index, event.target.value);
		}
		this.removeProductEvent();
  }
	removeProductEvent() {
		let removes = this.container.querySelectorAll('.remove');

		removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
	notesToggle() {
		let notes_toggle = document.getElementById('order-note-toggle');

		if ( ! notes_toggle ) {
			return;
		}

		notes_toggle.addEventListener('click', (event) => {
			notes_toggle.nextElementSibling.classList.add('active');
		});
		notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
			el.addEventListener('click', (event) => {
				notes_toggle.nextElementSibling.classList.remove('active');
				this.saveNotes();
			});
		});
	}
	saveNotes() {
		fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': `application/json`
			},
    	body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
	}
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

		dispatchCustomEvent('line-item:change:start', {
			quantity: quantity
		});
    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          let removes = this.container.querySelectorAll('.remove');

					if (removes) {
						removes.forEach((remove) => {
				      remove.addEventListener('click', (event) => {
				        this.updateQuantity(event.target.dataset.index, '0');

				        event.preventDefault();
				      });
				    });
					}
					this.notesToggle();

        }));
				dispatchCustomEvent('line-item:change:end', {
					quantity: quantity,
					cart: parsedState
				});
				if ( this.container.querySelector(`#CartDrawerItem-${line}`).length ) {
	        this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
				}
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
		this.querySelectorAll('.js-youtube').forEach((video) => {
	    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	  });
	  this.querySelectorAll('.js-vimeo').forEach((video) => {
	    video.contentWindow.postMessage('{"method":"pause"}', '*');
	  });
		this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
			localization.addEventListener("change", (e) => {
				localization.querySelector('form').submit();
			});
		});
	}
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
		let _this = this;
		// resize on initial load
		window.addEventListener('load', () => {
			document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
		});

		// delegated listener on change
		document.body.addEventListener('change', (e) => {
	    if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
	       _this.resizeSelect(e.target);
	    }
		});
		window.addEventListener('resize.resize-select', function() {
			document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
		});
	}

	resizeSelect(sel) {
	  let tempOption = document.createElement('option');
	  tempOption.textContent = sel.selectedOptions[0].textContent;

	  let tempSelect = document.createElement('select');
	  tempSelect.style.visibility = "hidden";
	  tempSelect.style.position = "fixed";
	  tempSelect.appendChild(tempOption);

	  sel.after(tempSelect);
		if ( tempSelect.clientWidth > 0 ) {
		  sel.style.width = `${+tempSelect.clientWidth + 12}px`;
		}
	  tempSelect.remove();
	}
}

if (typeof SelectWidth !== 'undefined') {
	new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
			button.addEventListener("click", (e) => {
		    button.classList.toggle('active');
			});
		});
	}
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
	class SidePanelContentTabs extends HTMLElement {
		constructor() {
	    super();
			this.buttons = this.querySelectorAll('button');
			this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
	  }
		connectedCallback() {
			this.setupButtonObservers();
		}
		disconnectedCallback() {

		}
		setupButtonObservers() {
			this.buttons.forEach((item, i) => {
				item.addEventListener('click', (e) => {
					this.toggleActiveClass(i);
				});
			});
		}
		toggleActiveClass(i) {
			this.buttons.forEach((button) => {
				button.classList.remove('tab-active');
			});
			this.buttons[i].classList.add('tab-active');

			this.panels.forEach((panel) => {
				panel.classList.remove('tab-active');
			});
			this.panels[i].classList.add('tab-active');
		}
	}

	customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
	class CollapsibleRow extends HTMLElement {
		constructor() {
	    super();

			this.details = this.querySelector('details');
    	this.summary = this.querySelector('summary');
    	this.content = this.querySelector('.collapsible__content');
		}
		connectedCallback() {
			this.setListeners();
		}
		setListeners() {
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				setTimeout(() => {
					this.prepareAnimations();
					this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
				}, 400);
			}
	  }
		prepareAnimations() {
			let _this = this,
					summary_height = this.querySelector('summary').offsetHeight,
					content_height = this.querySelector('.collapsible__content').offsetHeight,
					initial_height = summary_height,
					final_height = summary_height + content_height;

			this.tl = false;
			this.tl = gsap.timeline({
				reversed: !_this.details.open,
				paused: true,
				inherit: false,
				ease: 'sine.inOut',
				onStart: function() {
					_this.details.open = true;
					_this.details.style.overflow = 'hidden';
				},
				onReverseComplete: function() {
					_this.details.open = false;
					_this.details.style.overflow = '';
				}
			});

			this.tl
				.fromTo(_this.details, { height: function() {
					let h = Math.max( Math.max(initial_height, 0), 24 );
					return h;
				}, clearProps: 'height' }, { duration: 0.6, height: final_height, clearProps: 'height' });

			if ( this.details.open ) {
				this.tl.progress(1);
			}
		}
		instantClose() {
			this.tl.timeScale(10).reverse();
		}
		animateClose() {
			this.tl.timeScale(3).reverse();
		}
		animateOpen() {
			this.tl.timeScale(1).play();
		}
		onClick(e) {
			e.preventDefault();
			if ( this.tl.reversed() ) {
				this.tl.timeScale(1).play();
			} else {
				this.tl.timeScale(3).reverse();
			}
	  }
	}
	customElements.define('collapsible-row', CollapsibleRow);
}

window.addEventListener('load', () => {

	if (typeof Localization !== 'undefined') {
		new Localization();
	}
	if (typeof CartDrawer !== 'undefined') {
	  new CartDrawer();
	}
	if (typeof Header !== 'undefined') {
	  new Header();
	}
	if (typeof FooterMenuToggle !== 'undefined') {
		new FooterMenuToggle();
	}
});
